<template>
<div v-if="performances" class="pb-50" >
    <b-row>
        <b-col cols="12" md="12">
            <div class="panel-title">Partager un exploit</div>
        </b-col>
    </b-row>
    <div class="tab-panel">
        <div class="tab-row">
            <div class="tab active">
                <div>Partager</div>
            </div>
        </div>
    </div>
    <div class="panel-body">
        <b-row>
            <b-col cols="12" md="7" class="full-ipad-8">
                <div class="map-4">
                    <img class="map-3-img" :src="require('@/assets/img/pageicon/map-4.png')" />
                </div>
            </b-col>
            <b-col cols="12" md="5" class="full-ipad-4">
                <div class="social-icon-card">
                    <div class="exploit-text">Partager cet exploit via</div>
                    <div>
                        <div class="social-icon-row">
                            <div class="social-icon-col">
                                <img class="social-img" :src="require('@/assets/img/pageicon/insta-Icon.png')" />
                                <div class="social-text">Instagram</div>
                            </div>
                            <div class="social-icon-col">
                                <img class="social-img" :src="require('@/assets/img/pageicon/facebook-icon.png')" />
                                <div class="social-text">Instagram</div>
                            </div>
                        </div>
                        <div class="social-icon-row btm-65">
                            <div class="social-icon-col">
                                <img class="social-img" :src="require('@/assets/img/pageicon/mail-icon.png')" />
                                <div class="social-text">Mail</div>
                            </div>
                            <div class="social-icon-col">
                                <img class="social-img" :src="require('@/assets/img/pageicon/download-icon.png')" />
                                <div class="social-text">Télécharger l’image</div>
                            </div>
                        </div>
                    </div>
                    <div class="lpha-text">
                        Pour cette version lpha, nous te générons une image de ton exploit avec tes indicateurs de performance mais on te proposera très bientot des choses bien plus dingues
                    </div>
                </div>
            </b-col>
        </b-row>
    </div>
</div>
</template>

<script>
export default {
    computed: {
        performances() {
            return this.$store.getters['Performances/edit']
        }
    },
    methods: {

    },
    created() {

    }
}
</script>
